export default "__VITE_ASSET__7l_qq4jr__"